import { Injectable } from '@angular/core';

import { PicksRequest, Tv1PickData, Tv2PickData } from '@cds/query-objects';
import { flatten, keys } from 'lodash-es';

import { MyBetsBet } from '../../my-bets-base/models/my-bets-viewmodels';

@Injectable()
export class BetslipPicksRequestBuilderService {
    buildRequestFromBets(bets: MyBetsBet[]): PicksRequest {
        return {
            tv1Picks: flatten(bets.map(this.mapV1Offer)),
            tv2Picks: flatten(bets.map(this.mapV2Offer)),
        };
    }

    private mapV1Offer = (bet: MyBetsBet): Tv1PickData[] => {
        if (!bet.resultInfo) {
            return [];
        }

        return [
            {
                fixtureId: bet.resultInfo.eventId.toString(),
                gameId: bet.resultInfo.marketId,
                resultId: bet.resultInfo.optionId,
                useLiveFallback: true,
            },
        ];
    };

    private mapV2Offer = (bet: MyBetsBet): Tv2PickData[] => {
        if (bet.optionMarketInfo) {
            return this.mapOptionMarket(bet);
        }
        if (bet.participantInfo) {
            return this.mapParticipantMarket(bet);
        }
        if (bet.betBuilderInfo) {
            return this.mapBetBuilderPicks(bet);
        }

        return [];
    };

    private mapOptionMarket = (bet: MyBetsBet): Tv2PickData[] => {
        if (!bet.optionMarketInfo) {
            return [];
        }

        return [
            {
                fixtureId: bet.optionMarketInfo.fixtureCompoundId,
                optionMarketId: bet.optionMarketInfo.optionMarketId,
                isClassicBetBuilder: false,
            },
        ];
    };

    private mapParticipantMarket = (bet: MyBetsBet): Tv2PickData[] => {
        if (!bet.participantInfo) {
            return [];
        }

        return keys(bet.participantInfo.participantInfo).map((participant) => ({
            fixtureId: bet.participantInfo!.compoundId,
            participantId: +participant,
            isClassicBetBuilder: false,
        }));
    };

    private mapBetBuilderPicks = (bet: MyBetsBet): Tv2PickData[] => {
        if (!bet.betBuilderInfo) {
            return [];
        }

        return [
            {
                fixtureId: bet.betBuilderInfo.fixtureId.toString(),
                optionMarketId: bet.betBuilderInfo.optionMarketId,
                isClassicBetBuilder: true,
            },
        ];
    };
}
